import { Box, useTheme } from "@mui/material";
import { ErrorBoundary } from "@sentry/react";
import { useEffect } from "react";
import { EMPTY_SX } from "../../../utils/empty-sx";

import type { BoxProps } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

export interface PageContentProps extends PropsWithChildren, BoxProps {
  fullWidth?: boolean;
  centerContent?: boolean;
}

export const usePageContentMx = (): string => {
  const theme = useTheme();
  return `min(min(${theme.spacing(10)}, 5vw), 10vw)`;
};

export const PageContent: FC<PageContentProps> = ({
  children,
  maxWidth = "xl",

  fullWidth = false,
  title,
  sx = EMPTY_SX,
  centerContent = false,
  ...props
}) => {
  const pageContentMx = usePageContentMx();

  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  return (
    <Box
      mt={2}
      mb={4}
      sx={[
        centerContent
          ? (theme) => ({
              maxWidth: "lg",
              mx: "auto",
              px: theme.spacing(4),
            })
          : (theme) => ({
              mx: fullWidth ? theme.spacing(10) : pageContentMx,
            }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      <ErrorBoundary
        fallback={
          <Box>
            There was an error rendering the page content. If this issue persists, please contact
            customer support.
          </Box>
        }
      >
        <Box {...(!fullWidth && { maxWidth })} flexGrow={1}>
          {children}
        </Box>
      </ErrorBoundary>
    </Box>
  );
};
